/** 매출 언어팩 */
export const salesLocalePack = {
    id: 'No',
    hubName: '허브명',
    date: '일시',
    cacheClosingBalance: '캐시마감잔액',
    cacheSettlementTotal: '캐시정산합계',
    cacheCharge: '캐쉬충전금',
    withdrawalAmount: '출금액',
    deliveryCommission: '배달가맹비',
    deliveryAmount: '배달대행료',
    deliveryAmountCommission: '배달대행료수수료',
    orderChannelCommission: '주문채널유치수수료',
    sharedCommission: '공유수수료정산',
    smsCacheDeduction: 'SMS캐쉬차감',
    driverVirtualAccountCharge: '라이더가상계좌충전금',
    driverCacheClosingBalance: '라이더캐쉬마감액',
    insuranceDeposit: '예치금마감액',
    employmentInsuranceDeposit: '고용보험예치금마감액',
    occupationalAccidentInsuranceDeposit: '산재보험예금마감액',
    vatDeposit: '부가세예치금',
    franchiseeMinusCacheClosingBalance: '가맹점마이너스캐쉬마감액',
    driverCachePlusClosingBalance: '라이더캐쉬(플러스)마감액',
    withdrawalAvailableAmount: '출금가능금액마감액',
    other: '기타',
    // 이하 일별상세에서 사용
    todayNumber: '순번',
    category: '항목',
    depositAmount: '입출금금액',
    supplyPrice: '공급가액',
    vat: '부가세',
    hubCacheBalance: '허브캐쉬잔액',
    memo: '메모',
    receiptNumber: '접수번호',
    processor: '처리자',
};
/** 매출 테이블 필드팩 */
export const salesFieldPack = {
    // 번호
    id: 'id',
    // 허브명
    hubName: 'hubName',
    // 일시
    date: 'date',
    // 캐시마감잔액
    cacheClosingBalance: 'cacheClosingBalance',
    // 캐쉬정산합계
    cacheSettlementTotal: 'cacheSettlementTotal',
    // 캐쉬충전금
    cacheCharge: 'cacheCharge',
    // 출금액
    withdrawalAmount: 'withdrawalAmount',
    // 배달가맹비
    deliveryCommission: 'deliveryCommission',
    // 배달대행료
    deliveryAmount: 'deliveryAmount',
    // 배달대행료수수료
    deliveryAmountCommission: 'deliveryAmountCommission',
    // 주문채널유치수수료
    orderChannelCommission: 'orderChannelCommission',
    // 공유수수료정산
    sharedCommission: 'sharedCommission',
    // SMS캐쉬차감
    smsCacheDeduction: 'smsCacheDeduction',
    // 라이더가상계좌충전금
    driverVirtualAccountCharge: 'driverVirtualAccountCharge',
    // 라이더캐쉬마감액
    driverCacheClosingBalance: 'driverCacheClosingBalance',
    // 예치금마감액
    insuranceDeposit: 'insuranceDeposit',
    // 고용보험예치금마감액
    employmentInsuranceDeposit: 'employmentInsuranceDeposit',
    // 산재보험예금마감액
    occupationalAccidentInsuranceDeposit: 'occupationalAccidentInsuranceDeposit',
    // 부가세예치금
    vatDeposit: 'vatDeposit',
    // 가맹점마이너스캐쉬마감액
    franchiseeMinusCacheClosingBalance: 'franchiseeMinusCacheClosingBalance',
    // 라이더캐쉬(플러스)마감액
    driverCachePlusClosingBalance: 'driverCachePlusClosingBalance',
    // 출금가능금액마감액
    withdrawalAvailableAmount: 'withdrawalAvailableAmount',
    // 기타
    other: 'other',
    // 이하 일별상세에서 사용
    todayNumber: 'todayNumber',
    category: 'category',
    depositAmount: 'depositAmount',
    supplyPrice: 'supplyPrice',
    vat: 'vat',
    hubCacheBalance: 'hubCacheBalance',
    memo: 'memo',
    receiptNumber: 'receiptNumber',
    processor: 'processor',
};
/** 배송운임 */
export const invoiceDeliveryChargeLocalePack = {
    orderHub: '발주가맹점',
    category: '구분',
    unit: '단위',
    count: '건수',
    supplyPrice: '공급가액',
    vat: 'VAT',
    vatIncluded: 'VAT포함',
    dataCheck: '자료검증',
};
/** 배송운임 테이블 필드팩 */
export const invoiceDeliveryChargeFieldPack = {
    // 발주가맹점
    orderHub: 'orderHub',
    // 구분
    category: 'category',
    // 단위
    unit: 'unit',
    // 건수
    count: 'count',
    // 공급가액
    supplyPrice: 'supplyPrice',
    // VAT
    vat: 'vat',
    // VAT포함
    vatIncluded: 'vatIncluded',
    // 자료검증
    dataCheck: 'dataCheck',
};
/** 사용내역 */
export const invoiceUseHistoryLocalePack = {
    dataCheck: '자료검증',
    status: '상태',
    receiptDate: '접수일자',
    receiptTime: '접수시간',
    completionTime: '완료시간',
    cancelTime: '취소시간',
    franchiseeCode: '가맹점코드',
    orderHubName: '발주가맹점',
    distance: '거리(Km)',
    deliveryCommission: '배달대행료',
    deliveryCommissionVat: '배달대행료VAT',
    supportFund: '본사지원금',
    supportFundVat: '본사지원금VAT',
    deliveryFee: '배송운임',
    vat: 'VAT',
    vatIncluded: 'VAT 포함',
    receiptNumber: '접수번호',
    posReceiptNumber: 'POS접수번호',
    brandPosNo: '브랜드자체PosNo',
    executorCode: '수행지사코드',
    executorName: '수행지사명',
    cash: '현금',
    card: '카드',
    prePayment: '선결제',
    productFee: '상품요금',
    serviceFee: '봉사료/고객부담금',
    productAdditionFee: '상품할증료',
    additionalFee: '할증',
    additionalAdditionFee: '추가할증',
    areaAdditionFee: '구역할증',
};
/** 사용내역 테이블 필드팩 */
export const invoiceUseHistoryFieldPack = {
    // 자료검증
    dataCheck: 'dataCheck',
    // 상태
    status: 'status',
    // 접수일자
    receiptDate: 'receiptDate',
    // 접수시간
    receiptTime: 'receiptTime',
    // 완료시간
    completionTime: 'completionTime',
    // 취소시간
    cancelTime: 'cancelTime',
    // 가맹점코드
    franchiseeCode: 'franchiseeCode',
    // 발주가맹점명
    orderHubName: 'orderHubName',
    // 거리(Km)
    distance: 'distance',
    // 배달대행료
    deliveryCommission: 'deliveryCommission',
    // 배달대행료VAT
    deliveryCommissionVat: 'deliveryCommissionVat',
    // 본사지원금
    supportFund: 'supportFund',
    // 본사지원금VAT
    supportFundVat: 'supportFundVat',
    // 배송운임
    deliveryFee: 'deliveryFee',
    // VAT
    vat: 'vat',
    // VAT 포함
    vatIncluded: 'vatIncluded',
    // 접수번호
    receiptNumber: 'receiptNumber',
    // POS접수번호
    posReceiptNumber: 'posReceiptNumber',
    // 브랜드자체PosNo
    brandPosNo: 'brandPosNo',
    // 수행지사코드
    executorCode: 'executorCode',
    // 수행지사명
    executorName: 'executorName',
    // 현금
    cash: 'cash',
    // 카드
    card: 'card',
    // 선결제
    prePayment: 'prePayment',
    // 상품요금
    productFee: 'productFee',
    // 봉사료/고객부담금
    serviceFee: 'serviceFee',
    // 상품할증료
    productAdditionFee: 'productAdditionFee',
    // 할증
    additionalFee: 'additionalFee',
    // 추가할증
    additionalAdditionFee: 'additionalAdditionFee',
    // 구역할증
    areaAdditionFee: 'areaAdditionFee',
};
/** 상점 바로머니 언어팩 */
export const storeBaromoneyLocalePack = {
    id: 'No',
    hubName: '허브명',
    storeName: '상점명',
    storeType: '상점종류',
    date: '일시',
    cacheClosingBalance: '캐시마감잔액',
    cacheSettlementTotal: '캐시정산합계',
    cacheCharge: '캐쉬충전금액',
    withdrawalAmount: '캐쉬출금액',
    deliveryCommission: '배달가맹비',
    deliveryAmount: '배달대행료',
    orderChannelCommission: '주문가맹비',
    orderChannelAmountCommission: '주문대행수수료',
    smsCacheDeduction: 'SMS차감액',
    other: '기타',
};
/** 상점 바로머니 테이블 필드팩 */
export const storeBaromoneyFieldPack = {
    id: 'id',
    hubName: 'hubName',
    storeName: 'storeName',
    storeType: 'storeType',
    date: 'date',
    cacheClosingBalance: 'cacheClosingBalance',
    cacheSettlementTotal: 'cacheSettlementTotal',
    cacheCharge: 'cacheCharge',
    withdrawalAmount: 'withdrawalAmount',
    deliveryCommission: 'deliveryCommission',
    deliveryAmount: 'deliveryAmount',
    orderChannelCommission: 'orderChannelCommission',
    orderChannelAmountCommission: 'orderChannelAmountCommission',
    smsCacheDeduction: 'smsCacheDeduction',
    other: 'other',
};
/** 상점 바로머니 일별 상세 언어팩 */
export const storeBaromoneyDailyDetailLocalePack = {
    todayNumber: '순번',
    hubName: '허브명',
    date: '일시',
    category: '항목',
    depositAmount: '입출금금액',
    supplyPrice: '공급가액',
    vat: '부가세',
    hubCacheBalance: '지사캐쉬잔액',
    memo: '메모',
    receiptNumber: '접수번호',
    processor: '처리자',
};
/** 상점 바로머니 일별 상세 테이블 필드팩 */
export const storeBaromoneyDailyDetailFieldPack = {
    todayNumber: 'todayNumber',
    hubName: 'hubName',
    date: 'date',
    category: 'category',
    depositAmount: 'depositAmount',
    supplyPrice: 'supplyPrice',
    vat: 'vat',
    hubCacheBalance: 'hubCacheBalance',
    memo: 'memo',
    receiptNumber: 'receiptNumber',
    processor: 'processor',
};
